/** Správa firmy tabs — the company-admin area (správce, or a platform admin). */
export type ManagementTab = 'prehled' | 'clenove' | 'historie' | 'ebm' | 'ebm-report' | 'premier' | 'servis-email' | 'nabidky';

/**
 * Platform-admin tabs that used to live here; `/management?tab=…` links to
 * them redirect to the matching `/platforma` tab (see routes/management.tsx).
 */
export const LEGACY_PLATFORMA_TABS = {
  uzivatele: 'uzivatele',
  firmy: 'firmy',
  'cron-logs': 'ulohy',
} as const;
export type LegacyPlatformaTab = keyof typeof LEGACY_PLATFORMA_TABS;

export interface ManagementSearch {
  tab?: ManagementTab | LegacyPlatformaTab;
}

export function parseManagementSearch(input: Record<string, unknown>): ManagementSearch {
  const raw = input.tab;
  const tab: ManagementSearch['tab'] =
    raw === 'clenove' ||
    raw === 'historie' ||
    raw === 'ebm' ||
    raw === 'ebm-report' ||
    raw === 'premier' ||
    raw === 'servis-email' ||
    raw === 'nabidky' ||
    raw === 'prehled' ||
    (typeof raw === 'string' && raw in LEGACY_PLATFORMA_TABS)
      ? (raw as ManagementSearch['tab'])
      : undefined;
  return tab ? { tab } : {};
}
